import { goToPreviousPayload } from "~/events";
import { trackFbqEvent } from "~/events/fbqEventFactory";
import { trackersFactory } from "~/events/trackersFactory";

const trackers = trackersFactory("plan-payment-page");

const submitPlus = (): void => {
  trackers({ action: "submit-plus-membership-payment-cta" });
  trackFbqEvent("AddPaymentInfo", { content_ids: ["plus"] });
};

const submitPremium = (): void => {
  trackers({ action: "submit-premium-membership-payment-cta" });
  trackFbqEvent("AddPaymentInfo", {
    content_ids: ["premium"],
  });
};

const goToPreviousPage = (): void => trackers(goToPreviousPayload);

export const trackPlanPayment = {
  goToPreviousPage,
  submitPlus,
  submitPremium,
};
